
import React from 'react';
import { SparkleIcon } from './icons/SparkleIcon';
import { ShieldIcon } from './icons/ShieldIcon';

const Footer: React.FC<{ onNavigate: (page: 'welcome' | 'resources' | 'why-forgive-path' | 'legal') => void }> = ({ onNavigate }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-white border-t border-gray-200 pt-16 pb-12 mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    {/* Brand Column */}
                    <div className="md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white">
                                <SparkleIcon className="w-4 h-4" />
                            </div>
                            <span className="text-xl font-black text-gray-900 uppercase tracking-tighter">ForgivePath</span>
                        </div>
                        <p className="text-sm text-gray-500 font-medium leading-relaxed">
                            Empowering borrowers with Wall Street-grade automation to maximize student loan forgiveness.
                        </p>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="text-xs font-black text-gray-900 uppercase tracking-widest mb-6">Platform</h4>
                        <ul className="space-y-4 text-sm font-bold">
                            <li><button onClick={() => onNavigate('welcome')} className="text-gray-500 hover:text-blue-600 transition-colors">Home</button></li>
                            <li><button onClick={() => onNavigate('why-forgive-path')} className="text-gray-500 hover:text-blue-600 transition-colors">Why Choose Us</button></li>
                            <li><button onClick={() => onNavigate('resources')} className="text-gray-500 hover:text-blue-600 transition-colors">Resources</button></li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div>
                        <h4 className="text-xs font-black text-gray-900 uppercase tracking-widest mb-6">Compliance</h4>
                        <ul className="space-y-4 text-sm font-bold">
                            <li><button onClick={() => onNavigate('legal')} className="text-gray-500 hover:text-blue-600 transition-colors">Terms of Service</button></li>
                            <li><button onClick={() => onNavigate('legal')} className="text-gray-500 hover:text-blue-600 transition-colors">Privacy Policy</button></li>
                            <li><a href="mailto:ForgivePath@gmail.com" className="text-gray-500 hover:text-blue-600 transition-colors">Contact Support</a></li>
                        </ul>
                    </div>

                    {/* Guarantee */}
                    <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100">
                        <div className="flex items-center gap-2 mb-2">
                            <ShieldIcon className="w-5 h-5 text-blue-600" />
                            <h4 className="text-sm font-black text-blue-900 uppercase tracking-tighter">The ForgivePath Guarantee</h4>
                        </div>
                        <p className="text-xs text-blue-800 font-medium leading-relaxed">
                            100% Money-Back Guarantee. If the government denies the application we prepared, we'll refund your service fee in full.
                        </p>
                    </div>
                </div>

                {/* Disclosure Area */}
                <div className="border-t border-gray-100 pt-8">
                    <div className="max-w-4xl">
                        <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3">Consumer Disclosure & Non-Affiliation</h4>
                        <p className="text-[11px] leading-relaxed text-gray-400 font-medium text-justify">
                            ForgivePath is a private document preparation service and is <strong>not affiliated with the U.S. Department of Education</strong> or any government agency. We are not a lender, a servicer, or a shortcut to government benefits. You can apply for loan forgiveness programs (such as PSLF or IDR) for <strong>free</strong> without paid assistance at <a href="https://studentaid.gov" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">StudentAid.gov</a>. Our fees are solely for the identification of eligible programs and the organization and professional preparation of your application documents. We submit your applications electronically whenever permitted by the Department of Education, or provide you with a fully prepared packet and complete guidance for manual submission.
                        </p>
                    </div>
                    <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p className="text-[10px] font-black text-gray-400 uppercase tracking-tighter">
                            © {currentYear} YAS Enterprise Holdings LLC. All rights reserved.
                        </p>
                        <div className="flex gap-4">
                            <div className="text-[10px] font-black text-gray-300 uppercase tracking-widest border border-gray-200 px-2 py-1 rounded">256-bit Encryption</div>
                            <div className="text-[10px] font-black text-gray-300 uppercase tracking-widest border border-gray-200 px-2 py-1 rounded">Private & Secure</div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
